import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ behavior = 'smooth' }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // small timeout to allow route transitions/layout to settle
    const t = setTimeout(() => {
      window.scrollTo({ top: 0, behavior });
    }, 50);
    return () => clearTimeout(t);
  }, [pathname, behavior]);

  return null;
};

export default ScrollToTop;
